import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-reveal-candidate-button',
  templateUrl: './reveal-candidate-button.component.html',
  styleUrls: ['./reveal-candidate-button.component.scss'],
  standalone: false
})
export class RevealCandidateButtonComponent {
  @Input() candidateUuid: string = '';
  @Input() isRevealing: boolean = false;
  @Input() showText: boolean = true;
  @Input() buttonClass: string = 'p-btn-compact';
  @Input() iconOnly: boolean = false;
  
  @Output() revealClick = new EventEmitter<string>();

  onRevealClick(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    
    if (!this.isRevealing && this.candidateUuid) {
      this.revealClick.emit(this.candidateUuid);
    }
  }
}